import LinearProgress from "@material-ui/core/LinearProgress";
import { makeStyles } from "@material-ui/core/styles";
import { PRIMARY_COLOR, SECONDARY_COLOR } from "../../constants";
import { addAlpha } from "../../helpers/DataHelpers";

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  colorPrimary: {
    backgroundColor: addAlpha(SECONDARY_COLOR, 0.2),
  },
  barColorPrimary: {
    backgroundColor: SECONDARY_COLOR,
  },
  progressDisabled: {
    backgroundColor: addAlpha(PRIMARY_COLOR, 0.2),
  },
});

export default function ProgressBar({ progress, isDisabled }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <LinearProgress
        variant="determinate"
        value={progress}
        classes={{
          colorPrimary: isDisabled
            ? classes.progressDisabled
            : classes.colorPrimary,
          barColorPrimary: classes.barColorPrimary,
        }}
      />
    </div>
  );
}
